<form
	#purchaseForm="ngForm"
	class="flex items-end p-10"
	(ngSubmit)="purchaseInstrument(purchaseForm)"
	id="teranetForm"
>
	<app-input
		label="Instrument number"
		[(ngModel)]="instrumentNumber"
		[required]="true"
		name="instrumentNumber"
		[testHook]="testHooks.InstrumentNumber"
	></app-input>
	<app-button
		type="submit"
		class="ml-3"
		[loading]="purchasing"
		teranetLoginGuard
		[testHook]="testHooks.PurchaseButton"
		>Purchase</app-button
	>
</form>
<div *ngIf="error" class="flex flex-col items-center text-red">
	<span>Unable to purchase instrument.</span>
	<span>{{ error }}</span>
</div>
